// extracted by css-extract-rspack-plugin
export default {"cls1":"FriendlySutdModal-cls1_ZTi","cls2":"FriendlySutdModal-cls2_cCg FriendlySutdModal-cls1_ZTi"};